<template>
<!-- 英文 -->
  <div
    class="inherit"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="inherit">Inheritor</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Inheritor Details</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section">
        <div class="work" v-if="detail.isWork" @click="goHandleSearch()">
          <div class="work_name">Related Work</div>
        </div>
      <div class="title eng_title">
        {{ detail.englishName }}&nbsp;Introduce briefly
      </div>
      <div class="master engLishMaster">
        <div class="inheritorNameList" v-if="detail.inheritorLevelIdArrStr&&detail.inheritorLevelIdArrStr.length>0">
          <div class="inheritorNameItem" v-for="(items,index) in detail.inheritorLevelIdArrStr" :key="index">
            <div v-if="items&&items==1">Representative inheritor of Regong art, a national intangible cultural heritage project</div>
            <div v-if="items&&items==2">Representative inheritor of Regong art, an intangible cultural heritage project in Qinghai Province</div>
            <div v-if="items&&items==3">Representative inheritor of Regong art, an intangible cultural heritage project in Huangnan Prefecture, Qinghai Province</div>
            <div v-if="items&&items==4">Representative inheritor of Regong art, an intangible cultural heritage project in Tongren City, Huangnan Prefecture, Qinghai Province</div>
          </div>
        </div>
        <div class="artistsLevelNameList" v-if="detail.artistsLevelIdArrStr&&detail.artistsLevelIdArrStr.length>0">
          <div class="artistsLevelNameItem" v-for="(items,index) in detail.artistsLevelIdArrStr" :key="index">
            <div v-if="items&&items==1">Chinese Arts and Crafts Masters</div>
            <div v-if="items&&items==2">Master of Arts and Crafts in Qinghai Province</div>
            <div v-if="items&&items==3">Master of Arts and Crafts in Huangnan Prefecture, Qinghai Province</div>
            <div v-if="items&&items==4">Master of Arts and Crafts in Tongren City, Huangnan Prefecture, Qinghai Province</div>
          </div>
        </div>
        <div class="folkLevelNameList" v-if="detail.technologistLevel">
          <div v-if="detail.technologistLevel&&detail.technologistLevel==1">Qinghai Province Folk Crafts Master</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==2">Qinghai Provincial First Class Folk Craftsman</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==3">Qinghai Provincial Second Class Folk Craftsman</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==4">Qinghai Provincial Third Class Folk Craftsman</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==5">Folk Craftsman of Huangnan Prefecture, Qinghai Province</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==6">Folk Craftsman in Tongren City, Huangnan Prefecture, Qinghai Province</div>
        </div>
      </div>
      <div class="pic">
        <!-- 小与等于3 -->
          <div class="picture_one" v-if="detail.picture&&detail.picture.length<=3">
            <div class="picture_one_item" v-for="(item,index) in detail.picture" :key="index">
              <img :src="url + item.fileUrl" alt="" />
            </div>
          </div>
          <!-- 大于3 -->
          <div class="picture_two" v-if="detail.picture&&detail.picture.length>3">
            <div class="picture_two_box">
              <swiper :options="swiperOption" ref="mySwiper" v-if="detail.picture.length"
              >
                  <swiper-slide
                      class="swiper-slide"
                      v-for="(item, index) in detail.picture"
                      :key="index"
                  >
                      <img :src="url + item.fileUrl" />
                  </swiper-slide>
              </swiper>
              <div class="swiper-button-prev" slot="button-prev">
                <div>
                  <img src="../../assets/mobile/swiperLeft.png" alt="" />
                </div>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <div>
                  <img src="../../assets/mobile/swiperRight.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        <!-- <img :src="url + detail.picture[0].fileUrl" alt="" /> -->
      </div>
      <div class="content eng_content">{{ detail.englishDesc }}</div>
      </div>
    </div>
  </div>
  <!-- 藏文 -->
  <div class="inherit" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="inherit"> རྒྱུན་འཛིན་པ། </router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> རྒྱུན་འཛིན་པའི་གནས་ཚུལ་ཞིབ་ཕྲ། </span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section">
        <div class="work" v-if="detail.isWork" @click="goHandleSearch()">
          <div class="work_name_zang">འབྲེལ་ཡོད་བརྩམས་ཆོས་</div>
        </div>
      <div class="title">{{ detail.zangName }}ངོ་སྤྲོད།</div>
      <div class="master">
        <div class="inheritorNameList" v-if="detail.inheritorLevelIdArrStr&&detail.inheritorLevelIdArrStr.length>0">
          <div class="inheritorNameItem" v-for="(items,index) in detail.inheritorLevelIdArrStr" :key="index">
            <div v-if="items&&items==1">རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
            <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
            <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
            <div v-if="items&&items==4">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།</div>
          </div>
        </div>
        <div class="artistsLevelNameList" v-if="detail.artistsLevelIdArrStr&&detail.artistsLevelIdArrStr.length>0">
          <div class="artistsLevelNameItem" v-for="(items,index) in detail.artistsLevelIdArrStr" :key="index">
            <div v-if="items&&items==1">ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་</div>
            <div v-if="items&&items==2">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་</div>
            <div v-if="items&&items==3">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
            <div v-if="items&&items==4">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།</div>
          </div>
        </div>
        <div class="folkLevelNameList" v-if="detail.technologistLevel">
          <div v-if="detail.technologistLevel&&detail.technologistLevel==1">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ་</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==2">མཚོ་སྔོན་ཞིང་ཆེན་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་དང་པོ་</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==3">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གཉིས་པ་</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==4">མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གསུམ་པ་</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==5">མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་དམངས་ཁྲོད་བཟོ་རྩལ་པ་</div>
          <div v-if="detail.technologistLevel&&detail.technologistLevel==6">མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་མིའི་བཟོ་རྩལ་པ་</div>
        </div>
      </div>
      <div class="pic">
        <!-- 小与等于3 -->
          <div class="picture_one" v-if="detail.picture&&detail.picture.length<=3">
            <div class="picture_one_item" v-for="(item,index) in detail.picture" :key="index">
              <img :src="url + item.fileUrl" alt="" />
            </div>
          </div>
          <!-- 大于3 -->
          <div class="picture_two" v-if="detail.picture&&detail.picture.length>3">
            <div class="picture_two_box">
              <swiper :options="swiperOption" ref="mySwiper" v-if="detail.picture.length"
              >
                  <swiper-slide
                      class="swiper-slide"
                      v-for="(item, index) in detail.picture"
                      :key="index"
                  >
                      <img :src="url + item.fileUrl" />
                  </swiper-slide>
              </swiper>
              <div class="swiper-button-prev" slot="button-prev">
                <div>
                  <img src="../../assets/mobile/swiperLeft.png" alt="" />
                </div>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <div>
                  <img src="../../assets/mobile/swiperRight.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        <!-- <img :src="url + detail.picture[0].fileUrl" alt="" /> -->
      </div>
      <div class="content">{{ detail.zangDesc }}</div>
      </div>
    </div>
  </div>
  <!-- 中文 -->
  <div class="inherit" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <router-link to="inherit">传承人</router-link>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">传承人详情</span>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="socialDetail">
      <div class="section">
        <div class="work" v-if="detail.isWork" @click="goHandleSearch()">
          <div class="work_name">相关作品</div>
        </div>
        <div class="title">
          {{ detail.chineseName }}简介
        </div>
        <div class="master">
          <div class="inheritorNameList" v-if="detail.inheritorLevelIdArrStr&&detail.inheritorLevelIdArrStr.length>0">
            <div class="inheritorNameItem" v-for="(items,index) in detail.inheritorLevelIdArrStr" :key="index">
              <div v-if="items&&items==1">国家级非遗项目热贡艺术代表性传承人</div>
              <div v-if="items&&items==2">青海省非遗项目热贡艺术代表性传承人</div>
              <div v-if="items&&items==3">青海省黄南州非遗项目热贡艺术代表性传承人</div>
              <div v-if="items&&items==4">青海省黄南州同仁市非遗项目热贡艺术代表性传承人</div>
            </div>
          </div>
          <div class="artistsLevelNameList" v-if="detail.artistsLevelIdArrStr&&detail.artistsLevelIdArrStr.length>0">
            <div class="artistsLevelNameItem" v-for="(items,index) in detail.artistsLevelIdArrStr" :key="index">
              <div v-if="items&&items==1">中国工艺美术大师</div>
              <div v-if="items&&items==2">青海省工艺美术大师</div>
              <div v-if="items&&items==3">青海省黄南州工艺美术大师</div>
              <div v-if="items&&items==4">青海省黄南州同仁市工艺美术大师</div>
            </div>
          </div>
          <div class="folkLevelNameList" v-if="detail.technologistLevel">
            <div v-if="detail.technologistLevel&&detail.technologistLevel==1">青海省民间工艺大师</div>
            <div v-if="detail.technologistLevel&&detail.technologistLevel==2">青海省一级民间工艺师</div>
            <div v-if="detail.technologistLevel&&detail.technologistLevel==3">青海省二级民间工艺师</div>
            <div v-if="detail.technologistLevel&&detail.technologistLevel==4">青海省三级民间工艺师</div>
            <div v-if="detail.technologistLevel&&detail.technologistLevel==5">青海省黄南州民间工艺师</div>
            <div v-if="detail.technologistLevel&&detail.technologistLevel==6">青海省黄南州同仁市民间工艺师</div>
          </div>
        </div>
        <div class="pic">
          <!-- 小与等于3 -->
          <div class="picture_one" v-if="detail.picture&&detail.picture.length<=3">
            <div class="picture_one_item" v-for="(item,index) in detail.picture" :key="index">
              <img :src="url + item.fileUrl" alt="" />
            </div>
          </div>
          <!-- 大于3 -->
          <div class="picture_two" v-if="detail.picture&&detail.picture.length>3">
            <div class="picture_two_box">
              <swiper :options="swiperOption" ref="mySwiper" v-if="detail.picture.length"
              >
                  <swiper-slide
                      class="swiper-slide"
                      v-for="(item, index) in detail.picture"
                      :key="index"
                  >
                      <img :src="url + item.fileUrl" />
                  </swiper-slide>
              </swiper>
              <div class="swiper-button-prev" slot="button-prev">
                <div>
                  <img src="../../assets/mobile/swiperLeft.png" alt="" />
                </div>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <div>
                  <img src="../../assets/mobile/swiperRight.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <!-- <img :src="url + detail.picture[0].fileUrl" alt="" /> -->
        </div>
        <div class="content">{{ detail.chineseDesc }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { inheritDetail } from "../../api/management";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      language: this.$store.state.language,
      id: this.$route.query.id,
      detail: {},
      url: process.env.VUE_APP_WEB_URL,
      swiperOption: {
          loop: false, //是否循环轮播
          slidesPerView: 3,
          spaceBetween: 20, //间距
          //左右切换
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
      },
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {},
  created() {
    this.getNoticeDetail();
  },
  methods: {
    async getNoticeDetail() {
      const res = await inheritDetail(this.id);
      if (res.code == 1) {
        this.detail = res.data;
        // this.detail.content = this.detail.content.replace(
        //   /<img/g,
        //   "<img style='width:100%;height:auto;'"
        // );
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    goHandleSearch() {
      let name = this.detail.chineseName
      // if (this.language == "eng") {
      //   // 英文
      //   name = this.detail.englishName
      // } else if(this.language == "en") {
      //   // 藏文
      //   name = this.detail.zangName
      // } else {
      //   // 中文
      //   name = this.detail.chineseName
      // }
      this.$router.push({
        path: "/exhibitionSearch",
        query: {
          name: name,
          type:3
        },
      })
    }
  },
};
</script>
<style lang="scss">
.inherit {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .socialDetail {
    padding-bottom: 50px;
    .section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .work {
        display: flex;
        width: 100%;
        font-size: 28px;
        color: #ed201a;
        font-family: "fangzang";
        text-align: left;
        margin: 30px 0 0 0;
        .work_name, .work_name_zang {
          cursor: pointer;
        }
        .work_name:hover {
          text-decoration: underline;
        }
      }
      
      .title {
        padding: 30px 0 0 0;
        font-family: "fangzang";
        font-size: 22px;
      }
      .eng_title {
        font-family: "Times New Roman", Times, serif;
      }
      .pic {
        width: 100%;
        // width: 400px;
        // img {
        //   width: 100%;
        // }
        .picture_one {
          display: flex;
          justify-content: center;
          align-items: center;
          .picture_one_item {
            width: 300px;
            height: 400px;
            margin-right: 20px;
            img {
              height: 100%;
              width: 100%;
            }
          }
          .picture_one_item:nth-child(3n) {
            margin-right: 0;
          }
        }
        .picture_two {
          display: flex;
          justify-content: center;
          align-items: center;
          .picture_two_box {
            width: 940px;
            position: relative;
            .swiper-container {
              overflow: hidden;
              .swiper-wrapper {
                  .swiper-slide {
                      width: 300px;
                      height: 400px;
                      img {
                        width: 100%;
                        height: 100%;
                      }
                  }
              }
            }
            .swiper-button-prev::after {
              content: "";
            }
            .swiper-button-prev {
              position: absolute;
              background: none;
              background-color: #9a141b;
              width: 22px;
              height: 60px;
              left: 0;
              opacity: 1;
            }
            .swiper-button-next::after {
              content: "";
            }
            .swiper-button-next {
              position: absolute;
              background: none;
              background-color: #9a141b;
              width: 22px;
              height: 60px;
              right: 0;
            }
          }
        }
      }
      .master {
        margin: 20px 0;
        display: flex;
        font-size: 16px;
        // font-weight: 600;
        .inheritorNameList {
          display: flex;
          margin-right: 10px;
        }
        .artistsLevelNameList {
          display: flex;
          margin-right: 10px;
        }
        .folkLevelNameList {
          display: flex;
          margin-right: 10px;
        }
      }
      .engLishMaster {
        display: flex;
        flex-direction: column;
      }
      .content {
        margin-top: 20px;
        font-size: 20px;
        text-align: justify;
        text-indent: 2em;
        line-height: 1.5;
      }
      .eng_content {
        text-indent: 0;
      }
    }
  }
}
@media (max-width: 768px) {
  .inherit {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .exhibitionTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .mobilecloudLeft {
      position: absolute;
      bottom: -3.5%;
      right: 0;
      width: 1.25rem;
    }
    .socialDetail {
      padding-bottom: 0.3rem;
      .section {
        .work {
          width: 100%;
          font-size: 0.35rem;
          color: #ed201a;
          cursor: pointer;
          font-family: "fangzang";
          text-align: left;
          margin: .2rem 0 0 0;
        }
        .title {
        padding: 0.2rem 0 0 0;
        font-size: 0.3rem;
        color: #110b0b;
        }
        .master {
          font-size: 0.26rem;
          margin: .2rem;
          display: flex;
          flex-direction: column;
          color: #110b0b;
          .inheritorNameList {
            display: flex;
          }
          .artistsLevelNameList {
            display: flex;
          }
          .folkLevelNameList {
            display: flex;
          }
        }
        .pic {
          // width: 4rem;
          // img {
          //   width: 100%;
          // }
          .picture_one {
            .picture_one_item {
              width: 2rem;
              height: 2.67rem;
              margin-right: .2rem;
            }
          }
          .picture_two {
            .picture_two_box {
              width: 100%;
              position: relative;
              .swiper-container {
                overflow: hidden;
                .swiper-wrapper {
                    .swiper-slide {
                        width: 2rem;
                        height: 2.67rem;
                        img {
                          width: 100%;
                          height: 100%;
                        }
                    }
                }
              }
              .swiper-button-prev {
                width: 15px;
                height: 40px;
              }
              .swiper-button-next {
                width: 15px;
                height: 40px;
              }
            }
          }
        }
        .content {
          font-size: 0.28rem;
          width: 90%;
        }
      }
    }
  }
}
</style>
